<template>
  <div class="introduce_content">
    <img class="introduce_content_img" :src="returnImage()">
  </div>
</template>

<script>
import imageOption from "@/mixins/imageOption";
import util from "@/mixins/util";

export default {
  name: "IntroductionLayout",
  mixins: [imageOption,],
  components: {},
  props: {
    infoData: {},
  },
  data() {
    return {}
  },
  beforeRouterEnter() {
  },
  created() {
  },
  mounted() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  computed: {},
  methods: {
    returnImage() {
      return `${this.infoData.org_url}`;
    }
  },
  watch: {},
}
</script>

<style scoped>

</style>